import type { NotificationConfig } from "antd/es/notification/interface"

export type NotificationType = "success" | "info" | "warning" | "error"

const configNotification = {
  placement: "bottomRight"
  // getContainer: () => document.getElementById("main-layout")
} as NotificationConfig

/**
 * Errors sit top-right: bottom-right is where the workspace cards keep their
 * Save buttons, and a toast there hides the control the error asks you to use.
 */
const notificationOptions: Record<NotificationType, NotificationConfig> = {
  success: { ...configNotification, duration: 4 },
  info: { ...configNotification, duration: 6 },
  error: { ...configNotification, duration: 8, placement: "topRight" },
  warning: { ...configNotification, duration: 5 }
}

export { notificationOptions, configNotification }
